/* Pasta Gustosa — theme.js
   Nessuna dipendenza. Usa le API AJAX del carrello Shopify e la Section Rendering API. */
(() => {
  'use strict';

  const G = window.Gustosa || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ utilita' */
  G.formatMoney = (cents) => {
    const value = (Number(cents) || 0) / 100;
    const fmt = G.moneyFormat || '€{{amount_with_comma_separator}}';
    const comma = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/{{\s*amount_with_comma_separator\s*}}/, comma)
      .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/, comma.split(',')[0])
      .replace(/{{\s*amount\s*}}/, value.toFixed(2));
  };
  G.t = (str, vars = {}) => String(str || '').replace(/{{\s*(\w+)\s*}}/g, (_, k) => (k in vars ? vars[k] : ''));

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  let lockCount = 0;
  const lockScroll = () => { lockCount += 1; document.body.classList.add('is-locked'); };
  const unlockScroll = () => { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); };

  function trapFocus(container, event) {
    if (event.key !== 'Tab') return;
    const items = $$(FOCUSABLE, container).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* Pannello generico (menu, carrello, modale): apertura/chiusura accessibile */
  function makePanel(root, { panelSel, closeSel, onOpen, onClose }) {
    if (!root) return null;
    let lastFocus = null;
    const panel = $(panelSel, root);
    const api = {
      isOpen: () => root.classList.contains('is-open'),
      open(trigger) {
        if (api.isOpen()) return;
        lastFocus = trigger || document.activeElement;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        lockScroll();
        requestAnimationFrame(() => { (panel.querySelector('[data-autofocus]') || panel).focus({ preventScroll: true }); });
        onOpen && onOpen();
      },
      close() {
        if (!api.isOpen()) return;
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        unlockScroll();
        onClose && onClose();
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
    };
    root.addEventListener('click', (e) => { if (e.target.closest(closeSel)) api.close(); });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') api.close();
      trapFocus(panel, e);
    });
    return api;
  }

  /* ------------------------------------------------------------ toast */
  const toast = $('[data-toast]');
  let toastTimer;
  G.toast = (text) => {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3800);
  };

  /* ------------------------------------------------------------ header */
  const headerSection = $('.section-header');
  const header = $('[data-header]');
  const hasOverlap = !!$('[data-header-overlap]');
  let lastY = window.scrollY;
  let ticking = false;
  const megaOpen = () => !!$('.mega.is-open');

  function onScroll() {
    const y = window.scrollY;
    if (!headerSection) return;
    headerSection.classList.toggle('is-scrolled', y > 8);
    header && header.classList.toggle('is-solid', y > 8 || megaOpen());
    const goingDown = y > lastY + 4;
    const goingUp = y < lastY - 4;
    const shouldHide = goingDown && y > 320 && !megaOpen() && !document.body.classList.contains('is-locked');
    if (shouldHide) headerSection.classList.add('is-hidden');
    else if (goingUp || y < 120) headerSection.classList.remove('is-hidden');
    document.body.classList.toggle('header-hidden', headerSection.classList.contains('is-hidden'));
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();
  if (hasOverlap && header) {
    header.addEventListener('mouseenter', () => { if (window.matchMedia('(min-width: 1100px)').matches) header.classList.add('is-solid'); });
    header.addEventListener('mouseleave', () => { if (window.scrollY <= 8 && !megaOpen()) header.classList.remove('is-solid'); });
  }

  /* ------------------------------------------------------------ mega menu */
  $$('[data-mega-item]').forEach((item) => {
    const toggle = $('[data-mega-toggle]', item);
    const mega = $('[data-mega]', item);
    let hoverTimer;
    const open = () => {
      clearTimeout(hoverTimer);
      mega.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      header && header.classList.add('is-solid');
    };
    const close = () => {
      mega.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (header && window.scrollY <= 8 && !header.matches(':hover')) header.classList.remove('is-solid');
    };
    toggle.addEventListener('click', () => (mega.classList.contains('is-open') ? close() : open()));
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    item.addEventListener('mouseenter', () => { if (finePointer.matches) { clearTimeout(hoverTimer); hoverTimer = setTimeout(open, 90); } });
    item.addEventListener('mouseleave', () => { if (finePointer.matches) { clearTimeout(hoverTimer); hoverTimer = setTimeout(close, 160); } });
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); toggle.focus(); } });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    document.addEventListener('click', (e) => { if (!item.contains(e.target)) close(); });
  });

  /* ------------------------------------------------------------ dropdown lingua */
  $$('[data-dropdown]').forEach((dd) => {
    const btn = $('[data-dropdown-toggle]', dd);
    const setOpen = (open) => { dd.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', (e) => { e.stopPropagation(); setOpen(!dd.classList.contains('is-open')); });
    dd.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setOpen(false); btn.focus(); } });
    dd.addEventListener('focusout', (e) => { if (!dd.contains(e.relatedTarget)) setOpen(false); });
    document.addEventListener('click', (e) => { if (!dd.contains(e.target)) setOpen(false); });
  });

  /* ------------------------------------------------------------ annunci */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('[data-announcement-item]', bar);
    if (items.length < 2) return;
    let index = 0;
    let timer;
    const show = (i) => {
      index = (i + items.length) % items.length;
      items.forEach((el, n) => {
        el.classList.toggle('is-active', n === index);
        el.setAttribute('aria-hidden', n === index ? 'false' : 'true');
        $$('a', el).forEach((a) => (a.tabIndex = n === index ? 0 : -1));
      });
    };
    const play = () => { if (reduceMotion) return; clearInterval(timer); timer = setInterval(() => show(index + 1), (Number(bar.dataset.interval) || 5) * 1000); };
    const pause = () => clearInterval(timer);
    $('[data-announcement-next]', bar)?.addEventListener('click', () => { show(index + 1); play(); });
    $('[data-announcement-prev]', bar)?.addEventListener('click', () => { show(index - 1); play(); });
    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', play);
    bar.addEventListener('focusin', pause);
    bar.addEventListener('focusout', play);
    show(0);
    play();
  });

  /* ------------------------------------------------------------ menu mobile */
  const menuRoot = $('[data-menu-drawer]');
  const burger = $('[data-menu-open]');
  const menu = makePanel(menuRoot, {
    panelSel: '.menu-drawer__panel',
    closeSel: '[data-menu-close]',
    onOpen: () => burger && burger.setAttribute('aria-expanded', 'true'),
    onClose: () => burger && burger.setAttribute('aria-expanded', 'false')
  });
  burger && burger.addEventListener('click', () => menu.open(burger));
  window.matchMedia('(min-width: 1100px)').addEventListener('change', (e) => { if (e.matches && menu) menu.close(); });

  /* ------------------------------------------------------------ carrello */
  const cart = {
    drawer: null,
    sectionId: 'cart-drawer',
    root: () => $('[data-cart-drawer]'),
    init() {
      this.drawer = makePanel(this.root(), { panelSel: '.drawer__panel', closeSel: '[data-cart-close]' });
    },
    open(trigger) {
      if (!this.drawer) this.init();
      this.drawer && this.drawer.open(trigger);
    },
    async fetchJSON(url, body) {
      const res = await fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body ? JSON.stringify(body) : undefined
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart error');
      return data;
    },
    sectionsPayload() {
      return { sections: this.sectionId, sections_url: window.location.pathname };
    },
    render(sections, cartData) {
      const html = sections && sections[this.sectionId];
      if (html) {
        const wasOpen = this.drawer && this.drawer.isOpen();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-cart-drawer]', doc);
        const current = this.root();
        if (fresh && current) {
          $('.drawer__panel', current).innerHTML = $('.drawer__panel', fresh).innerHTML;
          if (wasOpen) $('.drawer__panel', current).focus({ preventScroll: true });
          // aggiorna le altre barre "box" della pagina con quella appena calcolata dal server
          const progress = $('[data-box-progress]', fresh);
          if (progress) $$('[data-box-progress]').forEach((el) => { if (!current.contains(el)) el.outerHTML = progress.outerHTML; });
        }
      }
      if (cartData && typeof cartData.item_count === 'number') this.updateCount(cartData.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.dataset.count = count;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });
    },
    async refresh() {
      const [sections, data] = await Promise.all([
        fetch(`${window.location.pathname}?sections=${this.sectionId}`).then((r) => r.json()),
        this.fetchJSON(`${G.routes.cart}.js`)
      ]);
      this.render(sections, data);
      return data;
    },
    async add(items, { open = true, trigger } = {}) {
      const payload = Object.assign({ items }, this.sectionsPayload());
      const data = await this.fetchJSON(`${G.routes.cartAdd}.js`, payload);
      const cartData = await this.fetchJSON(`${G.routes.cart}.js`);
      this.render(data.sections, cartData);
      if (open) this.open(trigger);
      else G.toast(G.strings.added);
      return cartData;
    },
    async change(key, quantity) {
      const payload = Object.assign({ id: key, quantity }, this.sectionsPayload());
      const data = await this.fetchJSON(`${G.routes.cartChange}.js`, payload);
      this.render(data.sections, data);
      if (document.querySelector('[data-main-cart]')) window.location.reload();
      return data;
    },
    async update(updates) {
      const payload = Object.assign({ updates }, this.sectionsPayload());
      const data = await this.fetchJSON(`${G.routes.cartUpdate}.js`, payload);
      this.render(data.sections, data);
      return data;
    }
  };
  G.cart = cart;
  cart.init();

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-cart]');
    if (opener) {
      e.preventDefault();
      toast && toast.classList.remove('is-visible');
      cart.open(opener);
      return;
    }
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('[data-cart-item]');
      line && line.classList.add('is-updating');
      cart.change(qtyBtn.dataset.cartQty, Math.max(0, Number(qtyBtn.dataset.qty))).catch(() => { G.toast(G.strings.error); line && line.classList.remove('is-updating'); });
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (!input) return;
    const line = input.closest('[data-cart-item]');
    line && line.classList.add('is-updating');
    cart.change(input.dataset.cartInput, Math.max(0, parseInt(input.value, 10) || 0)).catch(() => G.toast(G.strings.error));
  });

  /* ------------------------------------------------------------ stepper */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-stepper] [data-step]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-stepper]'));
    const min = Number(input.min || 0);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + Number(btn.dataset.step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------ form prodotto (pagina + aggiunta rapida) */
  async function submitProductForm(form, submitter) {
    const fd = new FormData(form);
    const id = fd.get('id');
    const quantity = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    if (!id) return;
    const btn = submitter || $('[type="submit"]', form);
    btn && btn.classList.add('is-loading');
    try {
      if (quick && quick.isOpen() && quickRoot.contains(form)) quick.close();
      await cart.add([{ id: Number(id), quantity }], { open: true, trigger: btn });
    } catch (err) {
      G.toast(err.message || G.strings.error);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    submitProductForm(form, e.submitter);
  });
  document.addEventListener('click', (e) => {
    const direct = e.target.closest('[data-add-variant]');
    if (!direct) return;
    direct.classList.add('is-loading');
    cart.add([{ id: Number(direct.dataset.addVariant), quantity: 1 }], { open: true, trigger: direct })
      .catch(() => G.toast(G.strings.error))
      .finally(() => direct.classList.remove('is-loading'));
  });

  /* ------------------------------------------------------------ aggiunta rapida */
  const quickRoot = $('[data-quick-modal]');
  const quick = makePanel(quickRoot, { panelSel: '.modal__panel', closeSel: '[data-quick-close]' });
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn || !quick) return;
    e.preventDefault();
    const url = btn.dataset.quickAdd;
    const sep = url.includes('?') ? '&' : '?';
    btn.classList.add('is-loading');
    try {
      const html = await fetch(`${url}${sep}section_id=quick-add`).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = $('.quick-add', doc) || doc.body;
      $('[data-quick-content]', quickRoot).innerHTML = content.outerHTML;
      $$('input[name="id"]', quickRoot).forEach((radio) => radio.addEventListener('change', () => {
        const price = $('[data-quick-price]', quickRoot);
        if (price) price.textContent = radio.dataset.price;
      }));
      if (cart.drawer && cart.drawer.isOpen()) cart.drawer.close();
      quick.open(btn);
    } catch (err) {
      window.location.href = url;
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ------------------------------------------------------------ pagina prodotto */
  const productRoot = $('[data-product]');
  if (productRoot) {
    const form = $('#ProductForm');
    const priceEl = $('[data-price]', productRoot);
    const unitEl = $('[data-unit]', productRoot);
    const floatIcon = $('[data-format-icon]', productRoot);
    const floatName = $('[data-format-name]', productRoot);
    const sticky = $('[data-sticky-atc]');
    const stickyFormat = $('[data-sticky-format]');
    const stickyPrice = $('[data-sticky-price]');

    $$('input[name="id"][type="radio"]', productRoot).forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        priceEl && (priceEl.textContent = radio.dataset.price);
        unitEl && (unitEl.textContent = radio.dataset.unit);
        const tpl = $(`template[data-icon-for="${radio.value}"]`, productRoot);
        if (floatIcon && tpl) { floatIcon.innerHTML = tpl.innerHTML; }
        floatName && (floatName.textContent = radio.dataset.format);
        stickyFormat && (stickyFormat.textContent = `${radio.dataset.format} · `);
        stickyPrice && (stickyPrice.textContent = radio.dataset.price);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
        showSlide(0);
      });
    });

    // galleria
    const slides = $$('[data-slide]', productRoot);
    const thumbs = $$('[data-thumb]', productRoot);
    function showSlide(i) {
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.slide === String(i)));
      thumbs.forEach((t) => t.setAttribute('aria-current', t.dataset.thumb === String(i) ? 'true' : 'false'));
    }
    thumbs.forEach((t) => t.addEventListener('click', () => showSlide(t.dataset.thumb)));

    // barra "aggiungi" fissa quando il pulsante principale esce dallo schermo
    const atc = $('[data-atc]', productRoot);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        $('[data-sticky-submit]', sticky).tabIndex = visible ? 0 : -1;
      }).observe(atc);
      $('[data-sticky-submit]', sticky).addEventListener('click', (e) => submitProductForm(form, e.currentTarget));
    }
  }

  /* ------------------------------------------------------------ slider */
  $$('[data-slider-section]').forEach((sec) => {
    const track = $('[data-slider-track]', sec);
    const prev = $('[data-slider-prev]', sec);
    const next = $('[data-slider-next]', sec);
    if (!track || !prev || !next) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 24 : 300) * (window.innerWidth > 900 ? 2 : 1);
    const update = () => {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      $('[data-slider-nav]', sec).hidden = track.scrollWidth <= track.clientWidth + 8;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ------------------------------------------------------------ filtri shop */
  const grid = $('[data-product-grid]');
  if (grid) {
    const chips = $$('[data-filter-tag]');
    const formatSelect = $('[data-filter-format]');
    const sortSelect = $('[data-sort]');
    const countEl = $('[data-shop-count]');
    const empty = $('[data-empty]');
    const promo = $('[data-grid-promo]', grid);
    const items = $$('[data-grid-item]', grid);
    const original = items.slice();
    const countTpl = countEl ? countEl.textContent.replace(/\d+/, '{{ count }}') : '';
    let tag = '';

    const params = new URLSearchParams(window.location.search);
    if (params.get('formato') && formatSelect) formatSelect.value = params.get('formato');
    if (params.get('tipo')) tag = params.get('tipo');

    function apply() {
      const fmt = formatSelect ? formatSelect.value : '';
      let visible = 0;
      items.forEach((li) => {
        const card = $('[data-product-card]', li);
        const tags = ` ${card.dataset.tags} `;
        const formats = ` ${card.dataset.formats} `;
        const show = (!tag || tags.includes(` ${tag} `)) && (!fmt || formats.includes(` ${fmt} `));
        li.hidden = !show;
        if (show) { visible += 1; $('.reveal', li)?.classList.add('is-in'); }
      });
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.filterTag === tag)));
      if (promo) promo.hidden = !!(tag || fmt);
      if (empty) empty.hidden = visible > 0;
      if (countEl) countEl.textContent = countTpl.replace('{{ count }}', visible);

      const mode = sortSelect ? sortSelect.value : 'manual';
      const sorted = original.slice();
      if (mode === 'price-asc') sorted.sort((a, b) => $('[data-product-card]', a).dataset.price - $('[data-product-card]', b).dataset.price);
      if (mode === 'price-desc') sorted.sort((a, b) => $('[data-product-card]', b).dataset.price - $('[data-product-card]', a).dataset.price);
      if (mode === 'name') sorted.sort((a, b) => $('[data-product-card]', a).dataset.name.localeCompare($('[data-product-card]', b).dataset.name));
      sorted.forEach((li) => grid.appendChild(li));
      if (promo && mode === 'manual') {
        const after = original[Math.min(3, original.length - 1)];
        after && after.after(promo);
      } else if (promo) {
        grid.appendChild(promo);
      }

      const url = new URL(window.location.href);
      fmt ? url.searchParams.set('formato', fmt) : url.searchParams.delete('formato');
      tag ? url.searchParams.set('tipo', tag) : url.searchParams.delete('tipo');
      window.history.replaceState({}, '', url.toString());
    }
    chips.forEach((c) => c.addEventListener('click', () => { tag = c.dataset.filterTag; apply(); }));
    formatSelect && formatSelect.addEventListener('change', apply);
    sortSelect && sortSelect.addEventListener('change', apply);
    $('[data-filter-reset]')?.addEventListener('click', () => { tag = ''; if (formatSelect) formatSelect.value = ''; apply(); });
    if (tag || (formatSelect && formatSelect.value)) apply();
  }

  /* ------------------------------------------------------------ comparsa al scroll */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ------------------------------------------------------------ parallasse foto a tutta larghezza */
  const parallax = $$('[data-parallax]');
  if (parallax.length && !reduceMotion) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      parallax.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        // 0,5 = foto al centro dello schermo; lo spostamento massimo e' il 12% dell'altezza della foto
        const progress = (r.top + r.height) / (vh + r.height);
        el.style.setProperty('--py', ((0.5 - progress) * 2 * r.height * 0.12).toFixed(1) + 'px');
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ------------------------------------------------------------ video di apertura (muto, in loop, al posto della foto) */
  $$('[data-intro-video]').forEach((video) => {
    const mobile = window.matchMedia('(max-width: 539px)').matches;
    if (mobile && video.dataset.posterMobile) video.poster = video.dataset.posterMobile;
    if (reduceMotion) return; // con "riduci movimento" resta la copertina
    video.muted = true;
    video.src = mobile ? video.dataset.srcMobile : video.dataset.src;
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
  });

  /* ------------------------------------------------------------ video (pagina Azienda) */
  $$('[data-video-feature]').forEach((box) => {
    const video = $('video', box);
    if (!video) return;
    const toggle = $('[data-video-toggle]', box);
    const sound = $('[data-video-sound]', box);
    let userPaused = false;
    const load = () => {
      if (video.dataset.src && !video.src) {
        video.src = window.matchMedia('(max-width: 899px)').matches && video.dataset.srcMobile ? video.dataset.srcMobile : video.dataset.src;
      }
    };
    const sync = () => {
      const playing = !video.paused;
      toggle.setAttribute('aria-pressed', String(playing));
      $('[data-video-label]', toggle).textContent = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
    };
    const play = () => { load(); const p = video.play(); if (p && p.catch) p.catch(() => {}); };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    toggle.addEventListener('click', () => {
      if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
    });
    sound.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.muted && video.paused) play();
      sound.setAttribute('aria-pressed', String(!video.muted));
      $('[data-video-sound-label]', sound).textContent = video.muted ? sound.dataset.labelOn : sound.dataset.labelOff;
    });
    // schermo intero: controlli nativi del browser (audio, avanzamento) solo in questa modalita'.
    // Se il browser non lo consente (es. anteprima dentro un iframe) il video si espande a tutta pagina.
    const fullBtn = $('[data-video-fullscreen]', box);
    const isFull = () => document.fullscreenElement === video || document.webkitFullscreenElement === video || video.webkitDisplayingFullscreen || box.classList.contains('is-expanded');
    const expand = (on) => {
      box.classList.toggle('is-expanded', on);
      document.documentElement.classList.toggle('scroll-lock', on);
      video.controls = on;
      fullBtn.setAttribute('aria-pressed', String(on));
      if (on) fullBtn.focus({ preventScroll: true });
    };
    if (fullBtn) {
      fullBtn.addEventListener('click', () => {
        if (box.classList.contains('is-expanded')) { expand(false); return; }
        load();
        play();
        if (video.requestFullscreen && document.fullscreenEnabled !== false) {
          video.requestFullscreen().then(() => { video.controls = true; }).catch(() => expand(true));
          setTimeout(() => { if (!isFull()) expand(true); }, 600);
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen(); // iPhone: player nativo
        } else {
          expand(true);
        }
      });
      const onFullChange = () => { if (!document.fullscreenElement && !document.webkitFullscreenElement && !box.classList.contains('is-expanded')) video.controls = false; };
      document.addEventListener('fullscreenchange', onFullChange);
      document.addEventListener('webkitfullscreenchange', onFullChange);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && box.classList.contains('is-expanded')) expand(false); });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        if (isFull()) return;
        if (entry.isIntersecting) {
          load();
          if (!reduceMotion && !userPaused) play();
        } else if (!video.paused) {
          video.pause();
        }
      }, { threshold: 0.35 }).observe(box);
    } else {
      load();
    }
    sync();
  });

  /* ------------------------------------------------------------ messaggi form */
  const formMessage = $('.form-message[data-autofocus]');
  if (formMessage) {
    formMessage.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    formMessage.focus({ preventScroll: true });
  }
})();
